module.exports = __webpack_public_path__ + "static/media/basemap_google_roadmap.4aa84a78.png";